import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $CardContentSmallThumbnailWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.lightGrey};
  // padding: ${spacing('xs')} ${spacing('sm')};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  margin-right: ${spacing('sm')};
  max-width: ${spacing(5)};
  height: ${spacing(5)};
  overflow: hidden;
`;

export const $CardContentSmallThumbnail = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  && svg {
    max-width: 18px;
    max-height: 18px;
  }

  && img {
    object-fit: contain;
    max-height: ${spacing('xxl')};
    max-width: ${spacing('xxl')};
  }
`;

export const $CardContentDescription = styled.div`
  flex: 2;
`;

export const $CardContentProductName = styled.div``;

export const $CardDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: row;
`;
